import * as React from 'react'

import { Icon, IconButton } from '@design/pt-ui'

type Props = {
  onClick: () => void
  collapsed: boolean
}

export function CollapseButton(props: Props) {
  return (
    <IconButton aria-label="share" onClick={props.onClick}>
      <Icon
        sx={{
          transform: props.collapsed ? 'rotate(270deg)' : 'rotate(0deg)',
          transition: 'transform 225ms cubic-bezier(0.4, 0, 0.6, 1)',
        }}>
        expand_more
      </Icon>
    </IconButton>
  )
}

export default CollapseButton
